/**
 * The version number at the foot of the sidebar.
 *
 * Dismissing the update toast should not mean losing the ability to update, so
 * once a newer build is waiting this badge turns into the button that applies
 * it and stays that way. That makes it the persistent half of the update story
 * and the toast the interruption — one mechanism, two surfaces.
 */

import { RefreshCw } from 'lucide-react';

import { APP_VERSION, useAppUpdate } from '@/lib/update-context.jsx';

export function VersionBadge() {
  const { updateReady, applyUpdate } = useAppUpdate();

  if (updateReady) {
    return (
      <button
        type="button"
        onClick={applyUpdate}
        className="flex w-full items-center justify-center gap-1.5 rounded-md bg-amber-400/90 px-2 py-1.5 text-xs font-semibold text-amber-950 transition-colors hover:bg-amber-400"
      >
        <RefreshCw className="h-3 w-3" />
        Update available — reload
      </button>
    );
  }

  return (
    <p className="px-2 text-center text-[11px] tabular-nums text-sidebar-foreground/45">
      Version {APP_VERSION}
    </p>
  );
}
